if (!customElements.get('purepicked-sticky-cart')) {
  customElements.define(
    'purepicked-sticky-cart',
    class extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.productInfo = document.getElementById(`MainProduct-${this.sectionId}`);
        this.nativeButton = this.productInfo?.querySelector('[name="add"]');
        this.button = this.querySelector('button');
        this.price = this.querySelector('[data-sticky-price]');
        this.nativePrice = this.productInfo?.querySelector(`#price-${this.sectionId}`);
        if (!this.productInfo || !this.nativeButton || !this.button) return;

        this.button.addEventListener('click', () => this.nativeButton.click());
        this.sync = this.sync.bind(this);
        this.observer = new MutationObserver(this.sync);
        this.observer.observe(this.productInfo, { childList: true, subtree: true, attributes: true });
        this.sync();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      sync() {
        const currentPrice = this.nativePrice?.querySelector('.price-item--sale, .price-item--regular');
        if (currentPrice && this.price) this.price.textContent = currentPrice.textContent.trim();
        this.button.disabled = this.nativeButton.disabled;
        const label = this.nativeButton.querySelector('span')?.textContent?.trim();
        if (label) this.button.textContent = label;
      }
    }
  );
}

function layoutPurePickedEditorialGrid(wrapper) {
  if (!wrapper) return;

  const findSection = (key) => wrapper.querySelector(`[id$="__${key}"]`);
  const leftIds = ['purepicked-why-lab', 'purepicked-suitability', 'purepicked-lab', 'purepicked-usage', 'purepicked-comparison'];
  const rightIds = ['purepicked-nutrition', 'purepicked-ingredients', 'purepicked-guide'];
  const leftSections = leftIds.map(findSection).filter(Boolean);
  const rightSections = rightIds.map(findSection).filter(Boolean);
  if (!leftSections.length && !rightSections.length) return;

  let pageWidth = wrapper.querySelector(':scope > .page-width');
  let grid = pageWidth?.querySelector('.pp-editorial-grid');
  let left = grid?.querySelector('.pp-editorial-col:first-child');
  let right = grid?.querySelector('.pp-editorial-col:nth-child(2)');
  if (!pageWidth) {
    // Same DOM pattern as product-component: a .page-width wrapper containing
    // a Dawn .grid, whose columns are plain .grid__item elements.
    pageWidth = document.createElement('div');
    pageWidth.className = 'page-width';
    // Match the hero's actual gallery/info split (product--{{ media_size }} in
    // section-main-product.css), instead of hardcoding one ratio, so this stays
    // correct whichever "Media size" the merchant picks in the theme editor.
    const mediaSize = document.querySelector('[id^="MainProduct-"]')?.dataset.mediaSize || 'medium';
    grid = document.createElement('div');
    grid.className = `pp-editorial-grid pp-editorial-grid--${mediaSize} grid grid--1-col grid--2-col-tablet`;
    left = document.createElement('div');
    left.className = 'pp-editorial-col pp-editorial-col--gallery grid__item';
    right = document.createElement('div');
    right.className = 'pp-editorial-col pp-editorial-col--info grid__item';
    grid.append(left, right);
    pageWidth.append(grid);
    (leftSections[0] || rightSections[0]).before(pageWidth);
  }

  if (window.matchMedia('(max-width: 749px)').matches) {
    const mobileIds = [...leftIds, ...rightIds];
    mobileIds.map(findSection).filter(Boolean).forEach((section) => left.appendChild(section));
    right?.remove();
    grid.classList.add('pp-editorial-grid--mobile');
    grid
      .querySelectorAll('details[open]:not(.pp-lab-panel)')
      .forEach((details) => details.removeAttribute('open'));
  } else {
    if (!right) {
      right = document.createElement('div');
      right.className = 'pp-editorial-col pp-editorial-col--info grid__item';
      grid.appendChild(right);
    }
    grid.classList.remove('pp-editorial-grid--mobile');
    leftSections.forEach((section) => left.appendChild(section));
    rightSections.forEach((section) => right.appendChild(section));
  }
}

function wrapPurePickedFlourSections() {
  const existingWrapper = document.querySelector('.flour-section[data-pp-section-wrapper]');
  if (existingWrapper) {
    layoutPurePickedEditorialGrid(existingWrapper);
    return;
  }

  const wrapperSectionIds = [
    'purepicked-why-lab',
    'purepicked-suitability',
    'purepicked-lab',
    'purepicked-usage',
    'purepicked-nutrition',
    'purepicked-ingredients',
    'purepicked-comparison',
    'purepicked-guide',
  ];
  const wrapperSections = [...document.querySelectorAll('.shopify-section')].filter((section) =>
    wrapperSectionIds.some((key) => section.id?.endsWith(`__${key}`))
  );
  const firstSection = wrapperSections[0];
  const lastSection = wrapperSections[wrapperSections.length - 1];
  if (!firstSection || !lastSection || firstSection.parentElement !== lastSection.parentElement) return;

  const wrapper = document.createElement('div');
  wrapper.className = 'flour-section';
  wrapper.dataset.ppSectionWrapper = '';
  firstSection.before(wrapper);

  let current = firstSection;
  while (current) {
    const next = current.nextElementSibling;
    wrapper.appendChild(current);
    if (current === lastSection) break;
    current = next;
  }
  layoutPurePickedEditorialGrid(wrapper);
}

function initPurePickedMobileGalleryDots() {
  if (!window.matchMedia('(max-width: 749px)').matches) return;
  document.querySelectorAll('.product__media-wrapper slider-component[id^="GalleryViewer-"]').forEach((slider) => {
    if (slider.dataset.ppGalleryDotsReady === 'true') return;
    const items = [...slider.querySelectorAll('.product__media-item')];
    const controls = slider.querySelector('.slider-buttons');
    if (items.length < 2 || !controls) return;

    let dots = slider.querySelector('.pp-gallery-dots');
    if (!dots) {
      dots = document.createElement('div');
      dots.className = 'pp-gallery-dots';
      items.forEach((item, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = `pp-gallery-dot${index === 0 ? ' is-active' : ''}`;
        dot.dataset.galleryIndex = index;
        dot.setAttribute('aria-label', `Show product image ${index + 1}`);
        dots.appendChild(dot);
      });
      controls.appendChild(dots);
    }
    [...dots.querySelectorAll('.pp-gallery-dot')].forEach((dot, index) => {
      const item = items[index];
      if (!item) return;
      dot.addEventListener('click', () => {
        if (typeof slider.setSlidePosition === 'function' && slider.sliderItemOffset) {
          slider.setSlidePosition(index * slider.sliderItemOffset);
        } else {
          item.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        }
      });
    });
    slider.addEventListener('slideChanged', (event) => {
      const activeIndex = Math.max(0, (event.detail?.currentPage || 1) - 1);
      dots.querySelectorAll('.pp-gallery-dot').forEach((dot, index) => dot.classList.toggle('is-active', index === activeIndex));
    });
    slider.dataset.ppGalleryDotsReady = 'true';
  });
}

// Product videos are set up as click-to-play (deferred-media) by Dawn for
// performance. Uploaded product videos should play automatically instead, so
// whenever a video slide becomes the active gallery slide (including the
// very first slide on page load), load and play it without waiting for a
// click on the poster/play button.
function autoplayPurePickedActiveVideo(gallery) {
  const activeItem = gallery.querySelector('.product__media-item.is-active');
  const deferred = activeItem?.querySelector('deferred-media');
  if (!deferred || deferred.hasAttribute('loaded') || typeof deferred.loadContent !== 'function') return;
  const templateTag = deferred.querySelector('template')?.content?.firstElementChild?.nodeName;
  if (templateTag === 'VIDEO' || templateTag === 'IFRAME') {
    deferred.loadContent(false);
  }
}

function initPurePickedVideoAutoplay() {
  document.querySelectorAll('.product__media-wrapper slider-component[id^="GalleryViewer-"]').forEach((gallery) => {
    if (gallery.dataset.ppVideoAutoplayReady === 'true') return;
    autoplayPurePickedActiveVideo(gallery);
    gallery.addEventListener('slideChanged', () => autoplayPurePickedActiveVideo(gallery));
    gallery.dataset.ppVideoAutoplayReady = 'true';
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    wrapPurePickedFlourSections();
    initPurePickedMobileGalleryDots();
    initPurePickedVideoAutoplay();
  });
} else {
  wrapPurePickedFlourSections();
  initPurePickedMobileGalleryDots();
  initPurePickedVideoAutoplay();
}

document.addEventListener('shopify:section:load', () => {
  wrapPurePickedFlourSections();
  initPurePickedMobileGalleryDots();
  initPurePickedVideoAutoplay();
});
// Shopify sync dependency: PurePicked PDP


/* ------------------------------------------------------------------
   Duplicate quantity input guard  —  added 5 Sep 2026

   sections/main-product.liquid renders TWO inputs named "quantity" and
   binds BOTH to the add-to-cart form via form="{{ product_form_id }}":

     #Quantity-<section>          the stock Dawn box. CSS-hidden by
                                  .product__info-container>.product-form__quantity
                                  { display:none } but STILL SUBMITTED.
     #PurchaseQuantity-<section>  the visible PurePicked box.

   Shopify keeps the LAST field of a repeated name. That happens to be the
   visible box today, but only because templates/product.json orders the
   blocks quantity_selector -> buy_buttons. Drag "Buy buttons" above
   "Quantity" in the theme editor -- a normal, sanctioned action -- and the
   hidden box becomes last, so every native submit and every Buy-with-Pay
   submit silently orders the variant minimum instead of the chosen amount.
   DOM order is load-bearing and nothing else records that.

   Separately, product-form.js calls formData.get('quantity'), which returns
   the FIRST match -- the hidden box -- so add-to-cart analytics report the
   wrong number while the cart records the right one.

   THE REAL FIX is deleting the form="{{ product_form_id }}" line from the
   hidden input in sections/main-product.liquid (~line 426, the only
   occurrence in that file). That file is 133KB, which is too large to push
   through the Admin API, so this detaches the input at runtime instead.
   Capture phase, so it runs before product-form.js builds its FormData, and
   it re-runs on every submit so a variant re-render cannot reinstate it.

   DELETE THIS BLOCK once the Liquid is corrected.
------------------------------------------------------------------ */
(function () {
  var SELECTOR =
    '.product__info-container > .product-form__quantity .quantity__input[form]';

  function detachHiddenQuantity() {
    document.querySelectorAll(SELECTOR).forEach(function (input) {
      input.removeAttribute('form');
    });
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (form && form.matches && form.matches('form[action*="/cart/add"]')) {
        detachHiddenQuantity();
      }
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', detachHiddenQuantity);
  } else {
    detachHiddenQuantity();
  }
})();
